import { render, staticRenderFns } from "./transferInto.vue?vue&type=template&id=60bd1807&scoped=true&"
import script from "./transferInto.vue?vue&type=script&lang=js&"
export * from "./transferInto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd1807",
  null
  
)

export default component.exports